//this in Figma was called Check-circle
import React from 'react'
import {Icon} from '@chakra-ui/react'

const SuccessIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" data-testid="success-icon" cursor="pointer" {...props}>
            <circle cx="20" cy="20" r="20" fill="#76B82A" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32.0325 14.0878L16.255 29.0685L8.9668 22.1484L11.0325 19.9728L16.255 24.9316L29.9668 11.9122L32.0325 14.0878Z"
                fill="white"
            />
        </Icon>
    )
}

export default SuccessIcon
